import * as React from "react";
import { useMemo } from "react";
import { numberFormat } from "helper/format-data";
import { Input } from "@/components/ui/input";

export interface InputNumberProps extends Omit<React.ComponentProps<"input">, "onChange" | "value"> {
  min?: string | number;
  currency?: string;
  value?: React.ComponentProps<"input">["value"] | null;
  onChange: (value: number) => void;
}

export const InputNumber = React.forwardRef<HTMLInputElement, InputNumberProps>(function InputNumber(
  { currency, value = 0, min, onChange, ...inputProps },
  forwardedRef,
) {
  const [isEditing, setIsEditing] = React.useState<boolean>(false);
  const toggleEditing = () => {
    setIsEditing(!isEditing);
  };
  const handleBlur = () => {
    toggleEditing();
  };

  const handleFocus = () => {
    toggleEditing();
  };

  const displayValue = useMemo(() => {
    if (Number(value)) {
      return numberFormat(Number(value));
    }
    return 0;
  }, [value]);

  return (
    <div className="relative">
      {currency && <div className="absolute inset-y-0 right-0 inline-flex items-center pr-2">{currency}</div>}
      {isEditing ? (
        <Input
          {...inputProps}
          onChange={(e) => onChange(Number(e.target.value))}
          value={value ?? undefined}
          type="number"
          min={min}
          ref={forwardedRef}
          onBlur={handleBlur}
        />
      ) : (
        <Input
          {...inputProps}
          onChange={(e) => onChange(Number(e.target.value))}
          onFocus={handleFocus}
          ref={forwardedRef}
          value={displayValue}
        />
      )}
    </div>
  );
});
